import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: '2em'
  },
}));

export default function CustomTabs({ content, onTabChange, selectedTab=0 }) {
  const classes = useStyles();
  const [value, setValue] = useState(selectedTab);

  useEffect(() => {
    // preselect the tab when it is passed as a prop
    setValue(selectedTab)
  },[selectedTab])

  const handleChange = (event, newValue) => {
    setValue(newValue);
    onTabChange(newValue);
  };

  const renderTabs = content.map(({ label }, index) => (
    <Tab key={label} label={label} {...a11yProps(index)} />
  ));

  const renderTabsPanel = content.map(({ label, component }, index) => (
    <TabPanel key={label} value={value} index={index}>
      {component}
    </TabPanel>
  ));

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange}>
          {renderTabs}
        </Tabs>
      </AppBar>

      {renderTabsPanel}
    </div>
  );
}
